import React, { useState } from 'react';
import { useIntl } from "react-intl";
import axios from 'axios';
import { navigate } from 'gatsby';

export default function ContactForm() {
    const intl = useIntl();
    const t = intl.formatMessage;

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [msg, setMsg] = useState("");

    async function handleSubmit() {
        await axios.post("https://y1a6y9z7f7.execute-api.ca-central-1.amazonaws.com/prod/sendMessage", {
            name: name,
            email: email,
            phoneNumber: phoneNumber,
            msg: msg,
            sendTo: { name: `Andmar ${t({id: "citySelectedMarker"})}`, email: t({id: "contact-info.email"}) }
        })
        .then(res => navigate("/?sent=success"))
        .catch(err => navigate("/?sent=failure")); 
    }

    return (
        <div className="officialForm">
            <div style={{display:"grid"}}>
                <input
                    id="name"
                    type="name"
                    name="name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    placeholder={t({ id: "card2.attributetext1" })}
                    style={{margin:"10px"}}
                />
                <input
                    id="email"
                    type="email"
                    name="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder={t({ id: "card2.attributetext2" })}
                    style={{margin:"10px"}}
                />
                <input
                    id="phoneNumber"
                    type="tel"
                    name="phoneNumber"
                    pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                    value={phoneNumber}
                    onChange={e => setPhoneNumber(e.target.value)}
                    placeholder={t({ id: "card2.attributetext4" })}
                    style={{margin:"10px"}}
                />
                <textarea
                    id="message"
                    name="message"
                    value={msg}
                    onChange={e => setMsg(e.target.value)}
                    placeholder={t({ id: "card2.attributetext3" })}
                    style={{margin:"10px", minHeight:"90px"}}
                />
                <input type="submit" value={t({ id: "card2.send-button" })} className="wpcf7-form-control wpcf7-submit" style={{margin:"10px", cursor: "pointer"}} onClick={handleSubmit} />
            </div>
        </div>
    );
}
